import * as $ from 'jquery';
import {setGridColumnsSelector} from './grid/gridColumnsSwitch.js';
import {setGridGangaSwitch} from './grid/gridGangaSwitch.js';
import {isAppSubdomain} from './utils.js';
import {appHasCapability} from './utils/app.js';
import {onLoad} from './utils/onLoad.js';

if (!isAppSubdomain()) {
    $(document).on('focus', '.card input[id^="input-comment-"]', function() {
        var placeholder = $(this).attr('placeholder');
        $(this).attr('placeholder', '');
        $(this).focusout(() => $(this).attr('placeholder', placeholder));
    });
}

onLoad( async () => {
  await removeFilterChips();
  setGridColumnsSelector();
  setGridGangaSwitch();
});

const removeFilterChips = async () => {
  if (!(await appHasCapability('native-chips-filters'))) {
        const chipsContainer = document.getElementById('filter-chips-container');
        if (chipsContainer) {
            chipsContainer.classList.remove('d-none');
        }
    }
};